import { useEffect } from 'react'
import { createFileRoute, Navigate } from '@tanstack/react-router'
import { getNavHref, getSalonHomeSegment } from '@/components/layout/app-navigation-items'
import { useWorkspaceNavVisibility } from '@/components/layout/use-workspace-nav-visibility'
import { useSalonModules } from '@/hooks/use-salon-modules'
import { useAccessContext } from '@/providers'
import { writeSalonHomeSegmentHint } from '@/lib/salon-home-segment-hint-storage'

export const Route = createFileRoute('/_auth/$orgId/')({
  component: SalonHome,
})

/**
 * "Open the salon" lands on Marketing for the agency team; salon staff land on Calendar when the salon runs it, else
 * Turns, else Marketing (then the rest of the rail, for someone who may open none of those), so a salon opens on what
 * it does use. Waits for the salon's
 * feature switches (the shell prefetches them) so it never bounces through a page that is about to disappear; a
 * settings failure resolves home from the fail-toward-hiding defaults rather than waiting forever.
 */
function SalonHome() {
  const { orgId } = Route.useParams()
  const access = useAccessContext()
  const visibility = useWorkspaceNavVisibility()
  const { isResolved, isError } = useSalonModules()
  const ready = isResolved || isError
  const homeSegment = ready ? getSalonHomeSegment(visibility, access) : undefined
  // Remember where home is on this device: the next cold open of the salon root warms this page's reads in the
  // shell's first wave instead of after the switches arrive (`OpeningPagePrefetch`).
  useEffect(() => {
    if (isResolved && homeSegment) writeSalonHomeSegmentHint(orgId, homeSegment)
  }, [isResolved, homeSegment, orgId])
  if (!homeSegment) return null
  return <Navigate to={getNavHref(orgId, homeSegment)} replace />
}
